import { Routes, Route } from "react-router-dom";
import { RequireAuthWrapper } from "../pages/RequireAuthWrapper";
import { AppLayout } from "../components/containers/appLayout/AppLayout";
import { SegmentSetupPage } from "../pages/segmentSetupPage";
import { SegmentHomePage } from "../pages/segmentHomePage";
import { SegmentSummaryPage } from "../pages/segmentSummaryPage";

export const SegmentRoutes = () => {
  return (
    <Routes>
      <Route path={""}>
        <Route
          path={""}
          element={
            <RequireAuthWrapper>
              <AppLayout pageTitle={"Segments"}>
                <SegmentHomePage />
              </AppLayout>
            </RequireAuthWrapper>
          }
        />
        <Route
          path={"new"}
          element={
            <RequireAuthWrapper>
              <AppLayout pageTitle={"New Segment"}>
                <SegmentSetupPage />
              </AppLayout>
            </RequireAuthWrapper>
          }
        />
        <Route path={":id"}>
          <Route
            path={""}
            element={
              <RequireAuthWrapper>
                <AppLayout pageTitle={"Summary"}>
                  <SegmentSummaryPage />
                </AppLayout>
              </RequireAuthWrapper>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};
